module.exports = __webpack_public_path__ + "de991929a7869b85fd444dcd7376b39d.svg";